<template>
  <div class="yk-ap-que-file-wrapper">
    <!-- <el-upload
        ref="upload"
          :file-list="questionFiles"
          :auto-upload="true"
          :data='access'
          :action='action'
          :multiple="false"
          :before-upload='beforeUpload'
          :on-remove="onRemoveHandler"
          :before-remove="beforeRemove"
          :on-success='onSuccessHandler'
          :on-error='onError'
          :on-preview="handlePreview">
        <el-button size="small" type="primary"  v-if="IsUpload">点击上传</el-button>
      </el-upload>  -->
      <div>
        <!-- <ul>
          <li v-for="(item,index) in questionFiles" :key="index">
            <div>{{item.name}}</div>
          </li>
        </ul> -->
        <el-table
          :data="questionFiles"
            stripe
          style="width: 100%" class="yk-table-dark"
          :show-header="false">
          <el-table-column
            width="180">
              <template slot-scope="scope">
                <i class="wl-icon-fujian" style="margin-left:50px;"></i>
              </template>
          </el-table-column>
          <el-table-column
            prop="name"
           >
          </el-table-column>
          <el-table-column width="200">
             <template slot-scope="scope">
              <!-- <el-button
                size="mini" @click="handlePreview(scope.row.docId)" title="下载" type="primary" v-if="scope.row.downloadUrl">下载</el-button> -->
              <el-button v-if="scope.row.downloadUrl" type="primary" size="mini"> <a :href="scope.row.downloadUrl" download="" class="a-download-class">点击下载</a></el-button>
              <el-button
                size="mini" @click="handlePreview(scope.row.docId)" title="查看" type="primary">查看</el-button>
              <!-- <el-button
                size="mini"
                type="danger" @click="deleteStudent(scope.row.id)" title="删除">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <source-preview :data.sync="sourceUrl"></source-preview> -->
       <!--课件预览-->
      <div class="PreviewResourcces" v-show="dialogVisiblePreviewResources">
        <i @click="dialogClose()" style="color:red;font-size:35px;position: fixed;top: 100px;" class="el-icon-close icon-closeimg"></i>
        <PreparingCourseware v-if="dialogVisiblePreviewResources" :sourceId="docId" :savesession="false" @dialogVisiblePreviewResources="dialogClose()"></PreparingCourseware>
      </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import uploader from 'lib/mixins/uploader';
import PreparingCourseware from '../PreparingCourseware.vue';
export default {
  name: 'oss-question-file',
  components: {
    PreparingCourseware
  },
  mixins: [uploader],
  props: {
    fileIds: {
      type: Array,
      default: ''
    },
    filesList: {
      type: Array,
      default: {
        Id: String,
        DocTitle: String,
        DocUrl: String,
        DownloadUrl: String
      }
    },
    IsUpload: {
      type: Boolean,
      default: true
    }
  },
  created() {
    // this.questionFiles = [];
    let list = [];
    this.filesList.forEach(element => {
      list.push({
        name: element.DocTitle,
        url: element.DocUrl,
        docId: element.Id,
        downloadUrl:element.DownloadUrl==undefined?"":element.DownloadUrl
      });
      // this.fileIds.push(element.Id);
    });
    this.$nextTick(() => {
      this.questionFiles = list;
    });
  },
  data() {
    return {
      questionFiles: [],
      sourceUrl: {
        id: '',
        url: '',
        type: '',
        docName: '',
        docType: 0
      },
      docId: '',
      dialogVisiblePreviewResources: false
    };
  },
  watch: {
    filesList: function(val) {
      // this.questionFiles = [];
      let list = [];
      val.forEach(element => {
       list.push({
          name: element.DocTitle,
          url: element.DocUrl,
          docId: element.Id,
          downloadUrl: element.DownloadUrl==undefined?"":element.DownloadUrl
        });
        // this.fileIds.push(element.Id);
      });

      this.$nextTick(() => {
        this.questionFiles = list;
      });
    }
  },
  methods: {
    beforeUpload(file) {
      return this.addFile(file);
    },
    onRemoveHandler(file) {
      // if (this.onRemove) {
      //   this.onRemove();
      // }
      this.questionFiles = this.questionFiles.filter(
        p => p.docId !== file.docId
      );
      // this.fileIds.splice(this.fileIds.indexOf(file.docId), 1);
      this.fileIds = this.fileIds.filter(p => p !== file.docId);
      this.$emit('update:fileIds', this.fileIds);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    handlePreview(docId) {
      this.dialogVisiblePreviewResources = true;
      this.docId = docId;
      // GetFileInfo(docId).then(rst => {
      //   if (rst.status == -1) {
      //     this.$message.warning("文件转换失败不能预览");
      //   } else if (rst.status == -2) {
      //     this.$message.warning("文件正在转换请稍后预览");
      //   } else if (rst.status == 1) {
      //     this.sourceUrl = {
      //       url: rst.docPriviewUrl,
      //       type: rst.type,
      //       docName: rst.docName,
      //       docType: rst.docType,
      //       id:file.docId
      //     };
      //   } else {
      //     this.$message.warning(rst.msg);
      //   }
      // });
    },
    onSuccessHandler(res, file, uploadFiles) {
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
      }
      this.questionFiles.push({
        name: file.name,
        url: res.docPath,
        docId: res.docId
      });
      // this.fileIds.push(res.docId);
      this.$emit('update:fileIds', this.fileIds);
    }
  }
};
</script>
<style lang="scss">
.yk-ap-que-file-wrapper {
  //   .el-table__row:nth-child(even) {
  //     background-color: #3c4c66;
  //   }
  //   .el-table__row:nth-child(odd) {
  //     background-color: #3f5373;
  //   }
}
.PreviewResourcces {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2600;
  background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 100%;
  overflow: auto;
  .icon-closeimg {
      size: 26px;
    position: fixed;
    top: 20px;
    right: 20px;
    font-size: 35px;
    cursor: pointer;
    font-weight: bolder;
  }
}
.a-download-class{
  color: #fff;
  text-decoration: none;
}
</style>
